import { Route, Routes } from "react-router-dom";
import Calculator from "../calculator/calculator";



const Calculator_rou = () => {
    return <>
    <Calculator/>
    </>
    
}

export default Calculator_rou;